import moment from "moment";

import { LinkedContact } from "@/Common/Api/Patient/Dto/LinkedContact";
import { Guid } from "@/Common/Models/Guid";
import { OntarioPatientEnrollmentModel } from "@/Common/Models/Patient/PatientEnrollment/Ontario/OntarioPatientEnrollmentModel";
import { RAMQDispensateurClass } from "@/Common/Models/RAMQ/enums/RAMQDispensateurClass";
import { RAMQInfo } from "@/Common/Models/RAMQ/RAMQInfo";
import { RAMQInscription } from "@/Common/Models/RAMQ/RAMQInscription";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class PatientProfileEnrollmentHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_EnrollPatientClose, this.EnrollPatientClose);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_EnrollPatientClick, this.EnrollPatientClick);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_EnrollPatientTransmit, this.TransmitPatientEnrollment);

        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_TerminateEnrollmentClick, this.TerminateEnrollmentClick);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_TerminateEnrollmentCancel, this.TerminateEnrollmentClose);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_TerminateReasonChange, this.TerminateReasonChange);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_TerminateEnrollmentTransmitClick, this.TransmitTermination);

        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_ModifyEnrollmentDateClick, this.ModifyEnrollmentDateClick);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_ModifyResidentEditClick, this.ModifyResidentEditClick);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_ModifyResidentDeleteClick, this.ModifyResidentDeleteClick);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_ModifyRepEditClick, this.ModifyRepEditClick);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_ModifyRepDeleteClick, this.ModifyRepDeleteClick);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_ModifyLieuSuiviClick, this.ModifyLieuSuiviClick);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_ModifyCaracteristiqueClick, this.ModifyCaracteristiqueClick);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_ModifyCancel, this.CancelModification);

        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_TransmitEnrollmentDateClick, this.TransmitEnrollmentDate);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_TransmitEditResidentClick, this.TransmitEditResident);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_TransmitDeleteResidentClick, this.TransmitDeleteResident);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_TransmitEditRepClick, this.TransmitEditRep);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_TransmitDeleteRepClick, this.TransmitDeleteRep);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_TransmitLieuSuiviClick, this.TransmitLieuSuivi);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_TransmitCaracteristiqueClick, this.TransmitCaracteristique);

        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_DispensateurChange, this.DispensateurChange);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_NoGmfChange, this.NoGmfChange);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_DatePriseEffetChange, this.DatePriseEffetChange);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_ResidentChange, this.ResidentChange);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_RepFirstNameChange, this.RepFirstNameChange);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_RepLastNameChange, this.RepLastNameChange);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_RepNAMChange, this.RepNAMChange);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_RepTypeChange, this.RepTypeChange);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_LieuSuiviChange, this.LieuSuiviChange);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_LieuSuiviDateChange, this.LieuSuiviDateChange);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_TerminateEnrollmentChange, this.TerminationChange);

        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_CaracteristiqueSante1Change, this.CaracteristiqueSante1Change);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_CaracteristiqueSante2Change, this.CaracteristiqueSante2Change);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_CaracteristiqueSante3Change, this.CaracteristiqueSante3Change);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_CaracteristiqueSanteDate1Change, this.CaracteristiqueSanteDate1Change);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_CaracteristiqueSanteDate2Change, this.CaracteristiqueSanteDate2Change);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_CaracteristiqueSanteDate3Change, this.CaracteristiqueSanteDate3Change);

        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_RAMQErrorDialogGoEdit, this.RAMQDialogReturnToEdit);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_CloseRAMQErrorDialog, this.CloseRAMQErrorDialog);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_CloseRAMQQuestionDialog, this.CloseRAMQQuestionDialog);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_RAMQQuestionDialogYes, this.RAMQQUestionDialogYes);

        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_GenerateEmptyFormClick, this.GenerateEmptyFormClick);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_EnrollPatientTransmitAndPrint, this.EnrollPatientTransmitAndPrint);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_GenerateRAMQFormClick, this.GenerateRAMQFormClick);
        this.RegisterOperation(LocalPatientOperations.Profile.Enrollment_SetOntarioEnrollmentPatientBanner, this.setOntarioEnrollmentPatientBanner);
    }

    private RAMQQUestionDialogYes(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsRAMQQuestionDialogVisible", false);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;

        if (enrollModel.get("IsTerminateEnrollmentPopup"))
            this.TransmitTermination(request, store, true);
        else if (enrollModel.get("IsEnrollmentFormEdit"))
            this.TransmitPatientEnrollment(request, store, true);
        else if (enrollModel.get("IsInEnrollmentEditMode"))
            this.TransmitEnrollmentDate(request, store, true);
        else if (enrollModel.get("IsInResidentEditMode"))
            this.TransmitEditResident(request, store, true);
        else if (enrollModel.get("IsInResidentDeleteMode"))
            this.TransmitDeleteResident(request, store, true);
        else if (enrollModel.get("IsInRepEditMode"))
            this.TransmitEditRep(request, store, true);
        else if (enrollModel.get("IsInRepDeleteMode"))
            this.TransmitDeleteRep(request, store, true);
        else if (enrollModel.get("IsInLieuSuiviEditMode"))
            this.TransmitLieuSuivi(request, store, true);
        else if (enrollModel.get("IsInCaracteristiqueSanteEditMode"))
            this.TransmitCaracteristique(request, store, true);

        this.CancelModification(request, store);
    }

    private CloseRAMQQuestionDialog(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsRAMQQuestionDialogVisible", false);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
        this.CancelModification(request, store);
    }

    private CloseRAMQErrorDialog(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsRAMQErrorDialogVisible", false);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
        this.CancelModification(request, store);
    }

    private RAMQDialogReturnToEdit(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsRAMQErrorDialogVisible", false);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private CancelModification(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsTerminateEnrollmentPopup", false);
        enrollModel = enrollModel.set("IsEnrollmentFormEdit", false);
        enrollModel = enrollModel.set("IsInEnrollmentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentDeleteMode", false);
        enrollModel = enrollModel.set("IsInRepEditMode", false);
        enrollModel = enrollModel.set("IsInRepDeleteMode", false);
        enrollModel = enrollModel.set("IsInLieuSuiviEditMode", false);
        enrollModel = enrollModel.set("IsInCaracteristiqueSanteEditMode", false);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
        sessionStore.hideGlobalOverlay();
    }

    private TransmitPatientEnrollment(request: LocalEvent, store: PatientStore, includeYesAnswer: boolean = false): void {
        store.ActionsProfile.enrollmentTransmit(request.PatientId, store, includeYesAnswer); // should be refactored
    }

    private TransmitEnrollmentDate(request: LocalEvent, store: PatientStore, includeYesAnswer: boolean = false): void {
        store.ActionsProfile.enrollmentTransmitDate(request.PatientId, store, includeYesAnswer);
    }

    private TransmitEditResident(request: LocalEvent, store: PatientStore, includeYesAnswer: boolean = false): void {
        store.ActionsProfile.enrollmentTransmitEditResident(request.PatientId, store, includeYesAnswer);
    }

    private TransmitDeleteResident(request: LocalEvent, store: PatientStore, includeYesAnswer: boolean = false): void {
        store.ActionsProfile.enrollmentTransmitDeleteResident(request.PatientId, store, includeYesAnswer);
    }

    private TransmitEditRep(request: LocalEvent, store: PatientStore, includeYesAnswer: boolean = false): void {
        store.ActionsProfile.enrollmentTransmitEditRep(request.PatientId, store, includeYesAnswer);
    }

    private TransmitDeleteRep(request: LocalEvent, store: PatientStore, includeYesAnswer: boolean = false): void {
        store.ActionsProfile.enrollmentTransmitDeleteRep(request.PatientId, store, includeYesAnswer);
    }

    private TransmitTermination(request: LocalEvent, store: PatientStore, includeYesAnswer: boolean = false): void {
        store.ActionsProfile.enrollmentTransmitPatientTermination(request.PatientId, store, includeYesAnswer);
    }

    private TransmitLieuSuivi(request: LocalEvent, store: PatientStore, includeYesAnswer: boolean = false): void {
        store.ActionsProfile.enrollmentTransmiLieuSuivi(request.PatientId, store, includeYesAnswer);
    }

    private TransmitCaracteristique(request: LocalEvent, store: PatientStore, includeYesAnswer: boolean = false): void {
        store.ActionsProfile.enrollmentTransmitCaracteristiqueSante(request.PatientId, store, includeYesAnswer);
    }

    private ModifyEnrollmentDateClick(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsTerminateEnrollmentPopup", false);
        enrollModel = enrollModel.set("IsEnrollmentFormEdit", false);
        enrollModel = enrollModel.set("IsInEnrollmentEditMode", true);
        enrollModel = enrollModel.set("IsInResidentEditMode", false);
        enrollModel = enrollModel.set("IsInRepEditMode", false);
        enrollModel = enrollModel.set("IsInLieuSuiviEditMode", false);
        enrollModel = enrollModel.set("IsInCaracteristiqueSanteEditMode", false);

        if (enrollModel.get("RAMQInscription")) {
            enrollModel = enrollModel.set("EnrollmentEffectiveDate", enrollModel.get("RAMQInscription").DatePrisedEffet);
        }

        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
        sessionStore.showGlobalOverlay(true);
    }

    private ModifyResidentEditClick(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsTerminateEnrollmentPopup", false);
        enrollModel = enrollModel.set("IsEnrollmentFormEdit", false);
        enrollModel = enrollModel.set("IsInEnrollmentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentEditMode", true);
        enrollModel = enrollModel.set("IsInRepEditMode", false);
        enrollModel = enrollModel.set("IsInLieuSuiviEditMode", false);
        enrollModel = enrollModel.set("IsInCaracteristiqueSanteEditMode", false);

        if (enrollModel.get("RAMQInscription")) {
            const residentPermit = enrollModel.get("RAMQInscription").ResidentPermit;
            const residentClass = enrollModel.get("RAMQInscription").ResidentClass;
            const selectedDoctor = residentClass === RAMQDispensateurClass.IPS
                ? RAMQInfo.ResolveActiveClinicianByRamqNumber(`${residentClass}${residentPermit}`)
                : RAMQInfo.ResolveActiveClinician(`R${residentPermit}`);

            if (selectedDoctor)
                enrollModel = enrollModel.set("SelectedResidentId", selectedDoctor.ContactFacetId);
        }

        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
        sessionStore.showGlobalOverlay(true);
    }

    private ModifyResidentDeleteClick(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsTerminateEnrollmentPopup", false);
        enrollModel = enrollModel.set("IsEnrollmentFormEdit", false);
        enrollModel = enrollModel.set("IsInEnrollmentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentDeleteMode", true);
        enrollModel = enrollModel.set("IsInRepEditMode", false);
        enrollModel = enrollModel.set("IsInLieuSuiviEditMode", false);
        enrollModel = enrollModel.set("IsInCaracteristiqueSanteEditMode", false);

        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
        sessionStore.showGlobalOverlay(true);
    }

    private ModifyRepEditClick(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsTerminateEnrollmentPopup", false);
        enrollModel = enrollModel.set("IsEnrollmentFormEdit", false);
        enrollModel = enrollModel.set("IsInEnrollmentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentDeleteMode", false);
        enrollModel = enrollModel.set("IsInRepEditMode", true);
        enrollModel = enrollModel.set("IsInRepDeleteMode", false);
        enrollModel = enrollModel.set("IsInLieuSuiviEditMode", false);
        enrollModel = enrollModel.set("IsInCaracteristiqueSanteEditMode", false);

        if (enrollModel.get("RAMQInscription")) {
            enrollModel = enrollModel.set("RepFirstName", enrollModel.get("RAMQInscription").RepresentantPrenom);
            enrollModel = enrollModel.set("RepLastName", enrollModel.get("RAMQInscription").RepresentantNom);
            enrollModel = enrollModel.set("RepNam", enrollModel.get("RAMQInscription").RepresentantNam);
            enrollModel = enrollModel.set("SelectedRepTypeId", enrollModel.get("RAMQInscription").RepresentantType);
        }

        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
        sessionStore.showGlobalOverlay(true);
    }

    private ModifyRepDeleteClick(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsTerminateEnrollmentPopup", false);
        enrollModel = enrollModel.set("IsEnrollmentFormEdit", false);
        enrollModel = enrollModel.set("IsInEnrollmentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentDeleteMode", false);
        enrollModel = enrollModel.set("IsInRepEditMode", false);
        enrollModel = enrollModel.set("IsInRepDeleteMode", true);
        enrollModel = enrollModel.set("IsInLieuSuiviEditMode", false);
        enrollModel = enrollModel.set("IsInCaracteristiqueSanteEditMode", false);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
        sessionStore.showGlobalOverlay(true);
    }

    private ModifyLieuSuiviClick(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsTerminateEnrollmentPopup", false);
        enrollModel = enrollModel.set("IsEnrollmentFormEdit", false);
        enrollModel = enrollModel.set("IsInEnrollmentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentDeleteMode", false);
        enrollModel = enrollModel.set("IsInRepEditMode", false);
        enrollModel = enrollModel.set("IsInRepDeleteMode", false);
        enrollModel = enrollModel.set("IsInLieuSuiviEditMode", true);
        enrollModel = enrollModel.set("IsInCaracteristiqueSanteEditMode", false);

        if (enrollModel.get("RAMQInscription")) {
            if (enrollModel.get("RAMQInscription").Lieux && enrollModel.get("RAMQInscription").Lieux.length > 0) {
                enrollModel = enrollModel.set("SelectedLieuSuiviId", enrollModel.get("RAMQInscription").Lieux[0].CodeGMF ? enrollModel.get("RAMQInscription").Lieux[0].CodeGMF.toString() : "");
            }
        }

        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
        sessionStore.showGlobalOverlay(true);
    }

    private ModifyCaracteristiqueClick(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsTerminateEnrollmentPopup", false);
        enrollModel = enrollModel.set("IsEnrollmentFormEdit", false);
        enrollModel = enrollModel.set("IsInEnrollmentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentEditMode", false);
        enrollModel = enrollModel.set("IsInResidentDeleteMode", false);
        enrollModel = enrollModel.set("IsInRepEditMode", false);
        enrollModel = enrollModel.set("IsInRepDeleteMode", false);
        enrollModel = enrollModel.set("IsInLieuSuiviEditMode", false);
        enrollModel = enrollModel.set("IsInCaracteristiqueSanteEditMode", true);

        if (enrollModel.get("RAMQInscription")) {
            if (enrollModel.get("RAMQInscription").CaracteristiqueSantes && enrollModel.get("RAMQInscription").CaracteristiqueSantes.length > 0) {
                enrollModel = enrollModel.set("CaracteristiqueSante1", enrollModel.get("RAMQInscription").CaracteristiqueSantes[0].CodeSante ? enrollModel.get("RAMQInscription").CaracteristiqueSantes[0].CodeSante.toString() : "");
                enrollModel = enrollModel.set("CaracteristiqueSante1Date", moment(enrollModel.get("RAMQInscription").CaracteristiqueSantes[0].Date).toDate());
            }
            if (enrollModel.get("RAMQInscription").CaracteristiqueSantes && enrollModel.get("RAMQInscription").CaracteristiqueSantes.length > 1) {
                enrollModel = enrollModel.set("CaracteristiqueSante2", enrollModel.get("RAMQInscription").CaracteristiqueSantes[1].CodeSante ? enrollModel.get("RAMQInscription").CaracteristiqueSantes[1].CodeSante.toString() : "");
                enrollModel = enrollModel.set("CaracteristiqueSante2Date", moment(enrollModel.get("RAMQInscription").CaracteristiqueSantes[1].Date).toDate());
            }
            if (enrollModel.get("RAMQInscription").CaracteristiqueSantes && enrollModel.get("RAMQInscription").CaracteristiqueSantes.length > 2) {
                enrollModel = enrollModel.set("CaracteristiqueSante3", enrollModel.get("RAMQInscription").CaracteristiqueSantes[2].CodeSante ? enrollModel.get("RAMQInscription").CaracteristiqueSantes[2].CodeSante.toString() : "");
                enrollModel = enrollModel.set("CaracteristiqueSante3Date", moment(enrollModel.get("RAMQInscription").CaracteristiqueSantes[2].Date).toDate());
            }
        }

        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
        sessionStore.showGlobalOverlay(true);
    }

    private EnrollPatientClick(request: LocalEvent, store: PatientStore): void {
        var ramqInfo = request.Get<RAMQInscription>("ramqInfo");

        var patient = patientStore.PatientModels[request.PatientId];

        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsEnrollmentFormEdit", true);
        if ((enrollModel.get("AvailableDispensateur") == null) || enrollModel.get("AvailableDispensateur").count() == 0)
            enrollModel = enrollModel.set("AvailableDispensateur", Immutable.fromJS([]));

        enrollModel = enrollModel.set("EnrollmentEffectiveDate", new Date());

        // Demographic//Assginee
        enrollModel = enrollModel.set("SelectedDispensateurId", "");
        enrollModel = enrollModel.set("DispensateurClass", "");
        enrollModel = enrollModel.set("DispensateurNumber", "");
        enrollModel = enrollModel.set("NoGmf", "");
        if (ramqInfo != null) {
            const clinician = RAMQInfo.activeProfessional(ramqInfo.DoctorClass, ramqInfo.DoctorLicence);
            if (clinician != null) {
                enrollModel = enrollModel.set("SelectedDispensateurId", clinician.ContactFacetId);
                enrollModel = enrollModel.set("DispensateurClass", ramqInfo.DoctorClass);
                enrollModel = enrollModel.set("DispensateurNumber", ramqInfo.DoctorLicence);
                enrollModel = enrollModel.set("NoGmf", ramqInfo.NoGmf);
            }
        }

        // Representative
        enrollModel = enrollModel.set("RepFirstName", "");
        enrollModel = enrollModel.set("RepLastName", "");
        enrollModel = enrollModel.set("RepNam", "");
        enrollModel = enrollModel.set("SelectedRepTypeId", "");
        let rep = patient.GetRepresentative();
        if (ramqInfo != null) {
            enrollModel = enrollModel.set("RepFirstName", ramqInfo.RepresentantPrenom);
            enrollModel = enrollModel.set("RepLastName", ramqInfo.RepresentantNom);
            enrollModel = enrollModel.set("RepNam", ramqInfo.RepresentantNam);
            enrollModel = enrollModel.set("SelectedRepTypeId", ramqInfo.RepresentantType);
        }
        else if (rep != null) {
            enrollModel = enrollModel.set("RepFirstName", LinkedContact.GetFirstName(rep));
            enrollModel = enrollModel.set("RepLastName", LinkedContact.GetLastName(rep));
            enrollModel = enrollModel.set("RepNam", LinkedContact.GetNAM(rep));
            enrollModel = enrollModel.set("SelectedRepTypeId", rep.RepresentativeType);
        }

        enrollModel = enrollModel.set("SelectedResidentId", null);
        enrollModel = enrollModel.set("DateDebutLieuSuivi", new Date());
        enrollModel = enrollModel.set("SelectedLieuSuiviId", sessionStore.getCurrentEmployee().getActiveSite().Model.Id);
        enrollModel = enrollModel.set("CaracteristiqueSante1", "");
        enrollModel = enrollModel.set("CaracteristiqueSante2", "");
        enrollModel = enrollModel.set("CaracteristiqueSante3", "");
        enrollModel = enrollModel.set("CaracteristiqueSante1Date", new Date());
        enrollModel = enrollModel.set("CaracteristiqueSante2Date", new Date());
        enrollModel = enrollModel.set("CaracteristiqueSante3Date", new Date());

        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;

        sessionStore.showGlobalOverlay(true);
    }

    private EnrollPatientClose(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsEnrollmentFormEdit", false);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
        sessionStore.hideGlobalOverlay();
    }

    private TerminateEnrollmentClick(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsTerminateEnrollmentPopup", true);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;

        sessionStore.showGlobalOverlay(true);
    }

    private TerminateEnrollmentClose(request: LocalEvent, store: PatientStore): void {
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("IsTerminateEnrollmentPopup", false);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;

        sessionStore.hideGlobalOverlay();
    }

    private TerminateReasonChange(request: LocalEvent, store: PatientStore): void {
        const value = request.Get<string>("value");
        let patientEnrollment = store.PatientProfileEnrollmentModels[request.PatientId];
        patientEnrollment = patientEnrollment.set("SelectedTerminationId", value);
        store.PatientProfileEnrollmentModels[request.PatientId] = patientEnrollment;
    }

    private DispensateurChange(request: LocalEvent, store: PatientStore): void {
        const contactFacetId = request.Get<string>("value");

        let patientEnrollment = store.PatientProfileEnrollmentModels[request.PatientId];
        if (contactFacetId) {
            const clinician = cacheStore.GetCliniciansPersonsByContactFacetId(contactFacetId);

            if (clinician) {
                const dispensateurClass = RAMQInfo.ResolveDispensableClass(clinician.EmployeeModel);
                if (!dispensateurClass)
                    return;

                let dispensateurNumber = "";
                if (dispensateurClass === RAMQDispensateurClass.IPS) {
                    dispensateurNumber = RAMQInfo.GetExtractDispensateurNumber(clinician.EmployeeModel.RamqNumber);
                }
                else if (dispensateurClass === RAMQDispensateurClass.Doctor) {
                    dispensateurNumber = clinician.EmployeeModel.Licences[0].LicenceNumber;
                }

                patientEnrollment = patientEnrollment.set("SelectedDispensateurId", contactFacetId);
                patientEnrollment = patientEnrollment.set("DispensateurNumber", dispensateurNumber);
                patientEnrollment = patientEnrollment.set("DispensateurClass", dispensateurClass);
                patientEnrollment = patientEnrollment.set("NoGmf", cacheStore.GetSiteById(sessionStore.getCurrentEmployee().getActiveSite().Model.ParentSiteId).Model.ClinicalCode);
                store.PatientProfileEnrollmentModels[request.PatientId] = patientEnrollment;
            }
        }
        else {
            patientEnrollment = patientEnrollment.set("SelectedDispensateurId", null);
            patientEnrollment = patientEnrollment.set("DispensateurNumber", null);
            patientEnrollment = patientEnrollment.set("DispensateurClass", null);
            patientEnrollment = patientEnrollment.set("NoGmf", null);
            store.PatientProfileEnrollmentModels[request.PatientId] = patientEnrollment;
        }
    }

    private NoGmfChange(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<string>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("NoGmf", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private DatePriseEffetChange(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<Date>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        var enrollModel = enrollModel.set("EnrollmentEffectiveDate", val);
        var enrollModel = enrollModel.set("DateDebutLieuSuivi", val);

        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private ResidentChange(request: LocalEvent, store: PatientStore): void {
        let val = request.Get<Guid>("value");

        let enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];

        // Reset
        enrollModel = enrollModel.set("SelectedResidentId", null);
        if (val != "") {
            let employee = cacheStore.GetCliniciansPersonsByContactFacetId(val);
            if (employee) // If found set Value
                enrollModel = enrollModel.set("SelectedResidentId", val);
        }

        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private RepFirstNameChange(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<string>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("RepFirstName", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private RepLastNameChange(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<string>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("RepLastName", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private RepNAMChange(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<string>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("RepNam", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private RepTypeChange(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<string>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("SelectedRepTypeId", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private LieuSuiviChange(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<string>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("SelectedLieuSuiviId", val);

        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private LieuSuiviDateChange(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<Date>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("DateDebutLieuSuivi", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private CaracteristiqueSante1Change(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<string>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("CaracteristiqueSante1", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private CaracteristiqueSante2Change(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<string>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("CaracteristiqueSante2", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private CaracteristiqueSante3Change(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<string>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("CaracteristiqueSante3", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private CaracteristiqueSanteDate1Change(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<Date>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("CaracteristiqueSante1Date", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private CaracteristiqueSanteDate2Change(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<Date>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("CaracteristiqueSante2Date", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private CaracteristiqueSanteDate3Change(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<Date>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("CaracteristiqueSante3Date", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private TerminationChange(request: LocalEvent, store: PatientStore): void {
        var val = request.Get<string>("value");
        var enrollModel = store.PatientProfileEnrollmentModels[request.PatientId];
        enrollModel = enrollModel.set("SelectedTerminationId", val);
        store.PatientProfileEnrollmentModels[request.PatientId] = enrollModel;
    }

    private GenerateEmptyFormClick(request: LocalEvent, store: PatientStore): void {
        var patientModel = store.PatientModels[request.PatientId];
        store.ActionsProfile.generateRamqForm(patientModel, true);
    }

    private EnrollPatientTransmitAndPrint(request: LocalEvent, store: PatientStore, includeYesAnswer: boolean = false): void {
        store.ActionsProfile.enrollmentTransmit(request.PatientId, store, includeYesAnswer, true);
    }

    private GenerateRAMQFormClick(request: LocalEvent, store: PatientStore): void {
        var patientModel = store.PatientModels[request.PatientId];
        store.ActionsProfile.generateRamqForm(patientModel, false);
    }

    private setOntarioEnrollmentPatientBanner(request: LocalEvent): void {
        const enrollmentStatus = request.Get<OntarioPatientEnrollmentModel>("enrollmentStatus");
        let patient = patientStore.PatientModels[request.PatientId];

        if (patient) {
            patient.setOntarioPatientEnrollmentModel(enrollmentStatus);

            // change info in patient banner
            let bannerModel = patientStore.PatientBannerModels[request.PatientId];
            bannerModel = bannerModel.set("Model", patient);
            patientStore.PatientBannerModels[request.PatientId] = bannerModel;

            // update store
            patientStore.PatientModels[request.PatientId] = patient;
        }
    }
}

export { PatientProfileEnrollmentHandler };
